import React from "react";

const MaintenancePage = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-[#0b0b0d] text-white px-6 text-center">
    <img
      src="/assets/echojham.logo2.png"
      alt="Echo Jham"
      className="h-14 w-auto object-contain mb-8"
    />
    <h1 className="text-2xl md:text-3xl font-black uppercase tracking-tight">We'll be back soon</h1>
    <p className="mt-3 max-w-md text-sm text-white/75 leading-relaxed">
      Echo Jham is temporarily unavailable while we finish an update. Please try again later.
    </p>
  </div>
);

export default MaintenancePage;
